import { useFlag } from '@calendly/feature-check-react'
import styled from 'astroturf/react'
import { useSelector } from 'react-redux'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
const colorStrokeStandard = 'var(--colorStrokeStandard, var(--coreColorNeutral400))'
import { TitleText } from '@calendly/ui/components/typography'
import { OnetrustSettingsButton } from '@calendly/onetrust/redux'
import { EventLocation, MainPanel } from '@calendly/booking-kit'

import Details from 'components/details'
import Marker from 'components/details/marker'
import EventTime from 'components/details/event_time'
import Timezone from 'components/details/timezone'
import Attendees from 'components/details/attendees'
import Profile from 'components/profile'
import Container from 'components/layout/container'
import Signup from 'components/signup'
import { eventSelector, timeNotationSelector } from 'selectors'
import { emailSelector, timezoneSelector } from 'selectors/invitee'
import { currentUserSelector } from 'selectors/user'
import { eventTypeSelector } from 'root-api'
import { useI18n } from 'locales'

import { ConfirmationFooter } from '../sso_confirmation_footer'

import { CancellationConfirmationDetails } from './cancellation_components/confirmation_details'
import { CancellationConfirmationHeader } from './cancellation_components/confirmation_header'
import _ConfirmationPanel from "confirmation-ConfirmationPanel.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/cancellation/confirmation.js?styleId=ConfirmationPanel";
import _Header from "confirmation-Header.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/cancellation/confirmation.js?styleId=Header";
import _Footer from "confirmation-Footer.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/cancellation/confirmation.js?styleId=Footer";
import _CookieSettingsButton from "confirmation-CookieSettingsButton.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/cancellation/confirmation.js?styleId=CookieSettingsButton";


const ConfirmationPanel = /*#__PURE__*/styled('div', null, {
  displayName: "ConfirmationPanel",
  styles: _ConfirmationPanel
})

const Header = /*#__PURE__*/styled('div', null, {
  displayName: "Header",
  styles: _Header
})

const Footer = /*#__PURE__*/styled('div', null, {
  displayName: "Footer",
  styles: _Footer
})

const CookieSettingsButton = /*#__PURE__*/styled(OnetrustSettingsButton, null, {
  displayName: "CookieSettingsButton",
  styles: _CookieSettingsButton,
  attrs: props => ({
    ...props,
    isTabletDown: useDeviceType('isTabletDown'),
    isDesktopUp: useDeviceType('isDesktopUp')
  })
})

const Confirmation = () => {
  const { i18n } = useI18n()
  const event = useSelector(eventSelector)
  const eventType = useSelector(eventTypeSelector)
  const email = useSelector(emailSelector)
  const timezone = useSelector(timezoneSelector)
  const timeNotation = useSelector(timeNotationSelector)
  const attendeesEmails = [email, ...event.guests]
  const currentUser = useSelector(currentUserSelector)
  const shouldShowNewConfirmationComponents = useFlag('sb_booking_confirmation_sso_feature', false)
  const profile = event.scheduled_profile

  return (
    <Container expanded>
      <MainPanel>
        <ConfirmationPanel>
          {shouldShowNewConfirmationComponents ? (
            <>
              <CancellationConfirmationHeader />
              <CancellationConfirmationDetails />
              {!eventType.unbranded && !currentUser && <ConfirmationFooter />}
            </>
          ) : (
            <>
              <Header>
                <Profile
                  avatar={profile.avatar_url}
                  name={profile.name}
                  logoUrl={profile.logo_url}
                />
                <TitleText level={2} size="large" as="h1">
                  {i18n.t('booking.templates.cancellation_confirmed')}
                </TitleText>
                {i18n.t('booking.templates.cancellation_confirmed_description', {
                  name: event.publishers_list
                })}
              </Header>
              <Details crossedItems>
                <Marker color={event.color} text={event.name} />
                <EventTime
                  source={event}
                  timezone={timezone}
                  timeNotation={timeNotation}
                />
                <Timezone value={timezone} />
                <EventLocation event={event} />
                <Attendees items={attendeesEmails} />
              </Details>
              <Footer>
                {!eventType.unbranded && !currentUser && <Signup />}
              </Footer>
            </>
          )}
          <CookieSettingsButton />
        </ConfirmationPanel>
      </MainPanel>
    </Container>
  )
}

export default Confirmation
